import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

export const AmendmentConstants = {
	Amendment: "Amendment",
	ClarificationLetter: "Clarification Letter",
	NewDocs: "New Docs",
};

// const AmendmentTypeOptions = Object.values(AmendmentConstants);

export default function AmendmentType({
	amendmentTypeOptions,
	amendmentType,
	handleAmendmentChange,
}) {
	return (
		<FormControl component="fieldset">
			<FormLabel component="legend">Amendment Type</FormLabel>
			<RadioGroup
				style={{ flexDirection: "row" }}
				aria-label="gender"
				name="gender1"
				value={amendmentType}
				onChange={handleAmendmentChange}>
				{amendmentTypeOptions.map((type) => (
					<FormControlLabel
						key={type}
						value={type}
						control={<Radio />}
						label={type}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
}
